var map = {
	"./ai.svg": 62656,
	"./ai_agent.svg": 59639,
	"./ai_bot.svg": 74180,
	"./ai_crawler.svg": 15838,
	"./all visitors.svg": 57631,
	"./android.svg": 8774,
	"./bing.svg": 4234,
	"./blackberry.svg": 56014,
	"./chrome.svg": 83874,
	"./desktop.svg": 61804,
	"./direct.svg": 22212,
	"./edge.svg": 62888,
	"./firefox.svg": 49049,
	"./human.svg": 46892,
	"./ie.svg": 46907,
	"./ios.svg": 11447,
	"./ipados.svg": 98045,
	"./iphone.svg": 85654,
	"./kindle.svg": 58697,
	"./linux.svg": 79553,
	"./macintosh.svg": 36691,
	"./macos.svg": 14550,
	"./mobile.svg": 79511,
	"./netscape.svg": 47039,
	"./new.svg": 99818,
	"./opera.svg": 66979,
	"./organic_search.svg": 47879,
	"./other.svg": 64688,
	"./other_bot.svg": 83987,
	"./palm.svg": 92616,
	"./playbook.svg": 12833,
	"./referral.svg": 16699,
	"./referred.svg": 84112,
	"./return.svg": 71273,
	"./safari.svg": 12194,
	"./samsung internet.svg": 6738,
	"./search_engine_bot.svg": 178,
	"./social.svg": 95607,
	"./tablet.svg": 6878,
	"./unidentified.svg": 11453,
	"./unknown.svg": 64333,
	"./windows phone.svg": 85559,
	"./windows.svg": 25718,
	"./windowsxp.svg": 33450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10575;